<template>
  <div class="table">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 个人中心
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <div style="margin-bottom: 20px">
          <el-input v-model="listQuery.admin_name" placeholder="姓名" style="width:200px;margin-right:20px;"></el-input>
          <el-date-picker
                  v-model="listQuery.updated_at"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
          </el-date-picker>
          <el-button
                  class="filter-item"
                  style="margin-left: 10px;"
                  type="primary"
                  icon="el-icon-search"
                  @click="handleFilter"
          >搜索</el-button>
        </div>

        <el-table border v-loading="listLoading" :data="tableData"  min-height="200"  max-height="1000" style="width: 100%">
          <el-table-column prop="id" label="ID"/>
          <el-table-column prop="name" label="姓名"/>
          <el-table-column prop="num" label="提交问题数"/>
          <el-table-column prop="updated_at" label="最后一次新增问题时间"/>
        </el-table>

        <pagination
                v-show="total>0"
                :total="total"
                :page.sync="listQuery.page"
                :limit.sync="listQuery.limit"
                @pagination="handleList"
        />
      </div>
    </div>
  </div>
</template>

<script>
    import {
        handleCenterListApi
    } from "@/api/faq.js";
    import Pagination from "@/components/pagination/index";
    export default {
        components: { Pagination },
        data() {
            return {
                // 列表
                listLoading: false,
                total: 0,
                tableData: [],
                listQuery: {
                    page: 1,
                    limit: 10
                },
                // 表单
            };
        },
        created() {
            this.handleList(this.listQuery);
        },
        methods: {
            handleList() {
                this.listLoading = true;
                handleCenterListApi(this.listQuery)
                    .then(response => {
                        const data = response.data.data;
                        this.tableData = data;
                        this.total = response.data.total;
                        setTimeout(() => {
                            this.listLoading = false;
                        }, 0.5 * 1000);
                    })
                    .catch(error => {
                        this.listLoading = false;
                    });
            },
            handleFilter() {
                this.listQuery.page = 1;
                this.handleList(this.listQuery);
            },
        }
    };
</script>
<style >
  div.el-transfer .el-transfer-panel {
    width: 400px;
  }
</style>
